import React from 'react';
import '../Style/Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>Copyright 2020</p>
    </footer>
  );
};

export default Footer;
